import React, { useMemo, Suspense } from 'react'
import BioSection from '../templates/BioSection'
import VideoSection from '../templates/VideoSection'
import ClientSection from '../templates/ClientSection'
import WorkSection from '../templates/WorkSection'
import ScrollGallery from '../templates/ScrollGallery'
import Contact from '../templates/Contact'
import BioBanner from '../templates/BioBanner'
import AboutUserSection from '../templates/AboutUserSection/'
import TestimonySection from '../templates/Testimonies'
import Lodging from '../templates/Lodging/'
import FeaturedGallery from '../templates/FeatureGallery/'
import EmailSignUp from '../templates/EmailSignUp'
import SlideShow from '../templates/SlideShow'

export default function LoadPageComponents ({ page, data }) {
  const viewKeys = {
    bio_section: BioSection,
    video: VideoSection,
    client_list: ClientSection,
    work_section: WorkSection,
    slide_show: SlideShow,
    contact_section: Contact,
    email_sign_up: EmailSignUp,
    name_banner: BioBanner,
    about_user_section: AboutUserSection,
    testimony_section: TestimonySection,
    scrolling_gallery: ScrollGallery,
    lodging: Lodging,
    static_gallery: Lodging,
    full_page_gallery: FeaturedGallery
  }

  const VIEW = useMemo(() => {
    if (!!page) {
      try {
        const View = viewKeys[page]
        if (!!View) {
          return (
            <Suspense fallback={<>...loading</>}>
              <View pageName={page} {...data} />
            </Suspense>
          )
        }
      } catch (error) {
        console.error(error)
      }
    }

    return <div>nothing on that mate!!!</div>
  }, [page, data, viewKeys])

  return (VIEW && VIEW) || null
}
